import {
  infomanLottie
} from './info-man-lottie';
import { jobListingItem } from './job-listing-item';
import { jobListingLink } from './job-listing-link';
import {
  slideshow
} from './slideshow';
import {
  stage00Lottie
} from './stage-00-lottie';
import jquery from 'jquery';


export default function blocks($container) {

  var $ = jquery;//review
  // tDODO - I've not done any changed on trhis file yet - still as mt blvoks

  var isadmin = false; // front end only
  // console.log("hello index.js blocks")

  if ($container.find('.dp-block-slideshow').length > 0) {

  // console.log("if .dp-block-slideshow should be front end only");

    $container.find('.dp-block-slideshow').each(function () {
      //  console.log("each .dp-block-slideshow'");

      var $thisblock = $(this);
      slideshow($thisblock, isadmin);

    });

  }; // .slideshow-block

  if ($container.find('.dp-block-info-management-home').length > 0) {

  // console.log("if. dp-block-info-management-home should be front end only");

    $container.find('.dp-block-info-management-home').each(function () {


      var $thisblock = $(this);
      infomanLottie($thisblock, isadmin);

    });

  }; // .dp-block-info-management-home


  if ($container.find('.dp-block-stage-00').length > 0) {

//  console.log("if. dp-block-info-management-home should be front end only");

    $container.find('.dp-block-stage-00').each(function () {

      var $thisblock = $(this);
      stage00Lottie($thisblock, isadmin);

    });

  }; // .dp-block-stage-00


  if ($container.find('.dp-block-jobs-listing-item').length > 0) {
    console.log("if .dp-block-jobs-listing-item");

    $container.find('.dp-block-jobs-listing-item').each(function () {
      var $thisblock = $(this);
      jobListingItem($thisblock, isadmin);
    });

  }

  if ($container.find('.dp-block-jobs-listing-link').length > 0) {
    console.log("if. dp-block-jobs-listing-link");

    $container.find('.dp-block-jobs-listing-link').each(function () {
      var $thisblock = $(this);
      jobListingLink($thisblock, isadmin);
    });

  }

  // console.log("blocks finished loading");

}; //blocks